// Copyright (c) 2019 Deere & Company
import './index.scss';
import EditableField from '../editable-field';
import LabeledFormInput from '../labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

const InputWithFaIcon = ( {
    className, highlightClass, isEditable, iconClassName,
    isMandatory, value, formatter, label, onIconClick,
    type = 'text', ...props
} ) => (
    <LabeledFormInput
        className={`${className} ${highlightClass}`}
        label={label}
        isRequired={isMandatory}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter( value ) : value}
        >
            <input
                {...props}
                onChange={props.onChange.bind( this )}
                type={type}
                value={value}
                disabled={props.isDisabled}
            />
            <span className={className} onClick={onIconClick}><i className={`dynamic-icon fa ${iconClassName}`} /></span>
        </EditableField>
    </LabeledFormInput>
);

InputWithFaIcon.displayName = 'InputWithFaIcon';
InputWithFaIcon.propTypes = {
    className: PropTypes.string.isRequired,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onIconClick: PropTypes.func.isRequired,
    type: PropTypes.string,
    iconClassName: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ).isRequired,
    isMandatory: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

export default InputWithFaIcon;
